export const ADVICE_META_DATA = {
	title: 'University Tips | University Advice',
	description:
		'Browse our advice hub for blogs, articles and tips on university life. We provide expert advice and guidance to give you all the information you need!',
};

export const ADVICE_SEARCH_META_DATA = {
	title: 'Search Student Advice Articles | Help & Information',
	description:
		'Search for student advice articles here. Find all the information you need, search from over 200 articles, filter by category and more.',
};

export const SORT_OPTIONS = [
	{
		id: 1,
		text: 'Newest',
		key: 'date_posted',
	},
	{
		id: 2,
		text: 'Oldest',
		key: 'date_posted',
	},
];

export const ARTICLE_REDIRECTS: Record<string, string> = {
	'ucas-track': 'ucas-hub',
};
